export enum Icons {
    Save = 'cloud_upload',
    Edit = 'settings',
}
